import type { SerializedCombinedMeter } from '@enmon/commons/lib/enmon';
import { readBootstrapMeterPlacementFields } from '@/features/location-bootstrap/location-bootstrap-meter-placement-mapper';
import { readBootstrapMeterTechnicalFields } from '@/features/location-bootstrap/location-bootstrap-meter-technical-mapper';
import type { LocationBootstrapMeter } from '@/features/location-bootstrap/location-bootstrap-types';
import { CACHED_METER_STATUSES } from '@/shared/meter-identification';

export function readLocationBootstrapMeter(meter: SerializedCombinedMeter): LocationBootstrapMeter | null {
  const _id = meter._id;
  const id = Number(meter.toolsId);

  if (!(_id && Number.isFinite(id))) {
    return null;
  }

  return {
    _id,
    apiKey: meter.apiKey,
    calibrated: meter.calibrated == null ? undefined : String(meter.calibrated),
    combinedMeterId: _id,
    id,
    internalNote: meter.internal_note,
    internalSupplyPointCode: meter.internal_supply_point_code,
    manufactured: meter.manufactured == null ? undefined : String(meter.manufactured),
    manufacturerId: meter.manufacturer,
    meterModelId: meter.meterModel,
    name: meter.name,
    newMeter: meter.new_meter,
    ownerName: meter.owner,
    ownerType: meter.ownerType,
    placement: meter.placement,
    raw: meter,
    commodity: meter.commodity,
    registers: meter.registers,
    serial: meter.serial,
    status: CACHED_METER_STATUSES.downloaded,
    submittedBy: meter.submitted_by,
    tenant: meter.tenant,
    toolsId: meter.toolsId,
    updatedAt: meter.updatedAt,
    ...readBootstrapMeterPlacementFields(meter),
    ...readBootstrapMeterTechnicalFields(meter),
  };
}
